import moment from "moment"
import * as R from "ramda"
import React from "react"
import { Link } from "react-router-dom"
import { Button, Header, Modal } from "semantic-ui-react"
import styled from "styled-components"
import { formatDateTime } from "../../utils"

const StyledCard = styled.div.attrs({
  className: "ui centered card mobile-not-show"
})`
  && {
    width: 90%;
    margin-bottom: 15px;
  }
`

export const OrderCard = ({ order }) => (
  <React.Fragment>
    <StyledCard>
      <div className="ui image">
        <img src={order.event.feature_image} />
      </div>
      <div className="content">
        <div
          className="right floated"
          style={{ marginTop: 40, width: "35%", textAlign: "center" }}
        >
          <p
            style={{
              fontWeight: "bold",
              fontSize: "1.5em",
              marginBottom: 0
            }}
          >
            <span style={{ color: "black" }}>สถานะ:</span>
            {!order.is_paid &&
            R.pathOr(null, ["payment", "approve"], order) === null ? (
              <span style={{ color: "red" }}> รอชำระเงิน</span>
            ) : !R.path(["payment", "approve"], order) && !order.is_paid ? (
              <span style={{ color: "#f0bb40" }}>
                {" "}
                รอตรวจสอบหลักฐานการชำระเงิน
              </span>
            ) : R.path(["payment", "approve"], order) || order.is_paid ? (
              <span style={{ color: "green" }}> ชำระเงินแล้ว</span>
            ) : null}
          </p>
          <div>
            {!order.is_paid &&
              !order.close_order &&
              R.isEmpty(R.path(["payment"], order)) && (
                <div style={{ marginTop: 10 }}>
                  <Link to={`/orders/${order.id}`}>
                    <Button color="teal">ชำระเงิน</Button>
                  </Link>
                  <Link to="/confirm-payment">
                    <Button className="ml-10" color="teal">
                      แจ้งโอนเงิน
                    </Button>
                  </Link>
                </div>
              )}
          </div>
        </div>
        <div>
          <h1>{order.event.title}</h1>
          <p>
            <span style={{ fontWeight: "bold" }}>
              ช่วงเวลาจัดส่งของที่ระลึก
            </span>
            :{formatDateTime(order.event.ship_date)} -{" "}
            {formatDateTime(moment(order.event.ship_date).add(7, "day"))}
          </p>

          <p>
            <Link to={`/orders/${order.id}`} style={{ fontWeight: "normal" }}>
              <u>ดูรายการสั่งซื้อ</u>
            </Link>

            {order.tracking && (
              <Modal
                trigger={
                  <span>
                    {` `}|{` `}
                    <Link to="#" style={{ fontWeight: "normal" }}>
                      <u>ติดตามสถานะเสื้อ</u>
                    </Link>
                  </span>
                }
              >
                <Header icon="archive" content="เลขพัสดุ" />
                <Modal.Content>
                  <p>{order.tracking}</p>
                  <p>
                    กรุณานำเลขพัสดุไปกรอกในเว็บไปรษณีย์ไทยเพื่อ เช็คสถานะการส่ง
                  </p>
                </Modal.Content>
                <Modal.Actions>
                  <a
                    href="http://track.thailandpost.co.th/tracking/result.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button color="olive">ไปรษณีย์ไทย</Button>
                  </a>
                </Modal.Actions>
              </Modal>
            )}
          </p>
        </div>
      </div>
    </StyledCard>
  </React.Fragment>
)

const StyledMobileCard = styled.div.attrs({
  className: "ui centered card"
})`
  && {
    display: none;
    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
      display: flex;
      width: 90%;
      margin-bottom: 15px;
      box-shadow: none;
    }
  }
`
export const MobileOrderCard = ({ order }) => (
  <React.Fragment>
    <StyledMobileCard>
      <div className="ui image">
        <img src={order.event.feature_image} />
      </div>
      <div className="content" />
      <div>
        <h1>{order.event.title}</h1>
        <p>
          <span style={{ fontWeight: "bold" }}>ช่วงเวลาจัดส่งของที่ระลึก</span>:
          {formatDateTime(order.event.ship_date)} -{" "}
          {formatDateTime(moment(order.event.ship_date).add(7, "day"))}
        </p>
        <p>
          <Link to={`/orders/${order.id}`} style={{ fontWeight: "normal" }}>
            <u>ดูรายการสั่งซื้อ</u>
          </Link>
        </p>
        {order.tracking && (
          <React.Fragment>
            <Modal
              trigger={
                <p>
                  <Link to="#" style={{ fontWeight: "normal" }}>
                    <u>ติดตามสถานะเสื้อ</u>
                  </Link>
                </p>
              }
            >
              <Header icon="archive" content="เลขพัสดุ" />
              <Modal.Content>
                <p>{order.tracking}</p>
                <p>
                  กรุณานำเลขพัสดุไปกรอกในเว็บไปรษณีย์ไทยเพื่อ เช็คสถานะการส่ง
                </p>
              </Modal.Content>
              <Modal.Actions>
                <a
                  href="http://track.thailandpost.co.th/tracking/result.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button color="olive">ไปรษณีย์ไทย</Button>
                </a>
              </Modal.Actions>
            </Modal>
          </React.Fragment>
        )}
      </div>
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <p style={{ fontWeight: "bold", fontSize: "1em", marginBottom: 0 }}>
          <span style={{ color: "black" }}>สถานะ:</span>

          {!order.is_paid &&
          R.pathOr(null, ["payment", "approve"], order) === null ? (
            <span style={{ color: "red" }}> รอชำระเงิน</span>
          ) : !R.path(["payment", "approve"], order) && !order.is_paid ? (
            <span style={{ color: "#f0bb40" }}>
              รอตรวจสอบหลักฐานการชำระเงิน
            </span>
          ) : R.path(["payment", "approve"], order) || order.is_paid ? (
            <span style={{ color: "green" }}> ชำระเงินแล้ว</span>
          ) : null}
        </p>

        {!order.is_paid &&
          !order.close_order &&
          R.isEmpty(R.path(["payment"], order)) && (
            <React.Fragment>
              <Link to={`/orders/${order.id}`}>
                <Button color="teal" className="mt10" style={{ width: "100%" }}>
                  ชำระเงิน
                </Button>
              </Link>
              <Link to="/confirm-payment">
                <Button color="teal" className="mt10" style={{ width: "100%" }}>
                  แจ้งโอนเงิน
                </Button>
              </Link>
            </React.Fragment>
          )}
      </div>
    </StyledMobileCard>
  </React.Fragment>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/OrderCard/index.js